module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-normal-small.130a5ff4.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-normal-small.png
// module id = 2651
// module chunks = 11